import React from 'react'
import { NavLink } from 'react-router-dom'
import { routersPath } from '../../../router/routes-path'
import {
  IconDollarReceiveSquare,
  IconDollarSendSquare,
  IconInvoice,
  IconSackDollar,
} from '../../../utils/icons'

export const salaryTabs = [
  {
    show: true,
    title: (
      <NavLink to={routersPath.SALARY_INPUT}>
        <IconDollarReceiveSquare width='22' height='22' fill='var(--color-main)' />
        Приход
      </NavLink>
    ),
    pages: [routersPath.SALARY_INPUT],
  },
  {
    show: true,
    title: (
      <NavLink to={routersPath.SALARY_OUTPUT}>
        <IconDollarSendSquare width='22' height='22' fill='var(--color-main)' />
        Расход
      </NavLink>
    ),
    pages: [routersPath.SALARY_OUTPUT],
  },
  {
    show: true,
    title: (
      <NavLink to={routersPath.SALARY_CRYPTO_CHANGE}>
        <IconInvoice width='22' height='22' fill='var(--color-main)' />
        Вывод крипты / Расчет ЗП
      </NavLink>
    ),
    pages: [routersPath.SALARY_CRYPTO_CHANGE],
  },
  {
    show: true,
    title: (
      <NavLink to={routersPath.SALARY_RETRIEVED}>
        <IconSackDollar width='22' height='22' fill='var(--color-main)' />
        Таблица списаний
      </NavLink>
    ),
    pages: [routersPath.SALARY_RETRIEVED],
  },
]
